import { render, staticRenderFns } from "./DkOfferItem.vue?vue&type=template&id=7771216f&"
import script from "./DkOfferItem.vue?vue&type=script&lang=js&"
export * from "./DkOfferItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports